import {treeAspectMinorTabgroup, wikiTab} from 'uix/views/utils'

const isDomainNode = ({treeNode}) => treeNode.nodeType == 'domain'
export const config = {
  ...treeAspectMinorTabgroup,
  acl: 'g:admin,g:debug',
  tabGroup: 'config',
  tabs: {
    start: {
      default: true,
      tabGroupDefault: true,
      enabled: isDomainNode,
      parts: ['ConfigDashboard'],
    },
    domain: {
      enabled: isDomainNode,
      parts: ['ShowConfig'],
    },
    frontend: {
      enabled: isDomainNode,
      parts: ['ShowFrontendConfig'],
    },
    edit: {
      tabGroupDefault: true,
      minorTabGroup: 'Editor',
      enabled: isDomainNode,
      parts: [
        {
          type: 'EditConfig',
          filters: ['getDatabaseConfigData'],
        },
      ],
    },
    history: {
      minorTabGroup: 'Editor',
      enabled: isDomainNode,
      parts: ['ConfigHistory'],
    },
    chain: {
      enabled: isDomainNode,
      parts: ['DomainConfigChain'],
    },
    css: {
      enabled: isDomainNode,
      parts: ['EditCSS'],
      label: 'CSS',
    },
    mods: {
      enabled: ({datatype}) => datatype == 1 || datatype == 10,
      parts: ['EditModsElementOrder'],
      label: 'MODS',
      order: 60, // config/type is 51
    },
    i18n: {
      enabled: isDomainNode,
      parts: ['I18NDiag'],
      label: 'I18N',
    },
  },
}
